import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../shared/components/ScreenLoading'

function ResourceNotifications() {
  const { error, msg, loading } = useSelector((state: IRootState) => state.resource)
  const { error: errorCategory, msg: msgCategory } = useSelector((state: IRootState) => state.resourcecategory)
  const { error: errorResourcetype, msg: msgResourcetype } = useSelector((state: IRootState) => state.resourcetype)

  return (
    <>
      <CustomSnackBar errors={[error, errorCategory, errorResourcetype]} msgs={[msg, msgCategory, msgResourcetype]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default ResourceNotifications
